import { formatDateTime } from "../../../Component/Common/formatDateTime";
import { ROLE_LABELS } from "../../../Component/Common/ROLE_LABELS";
import Badge from "../../../Component/RetUserComponents/Badge";
import SectionCard from "../../../Component/RetUserComponents/SectionCard";
import Account from "../../Profile/Account";
import { useContext, useEffect, useRef, useState } from "react";
import { BASE_URL } from "../../../config/api";

import { ChevronDown, ChevronRight, Eye, EyeOff, FileText, KeyRound, Lock, ShieldCheck } from "lucide-react";
import { toast } from "react-hot-toast";
import axios from "axios";
import { AnimatePresence, motion } from "framer-motion";
import DocumentsView from "../Retailer/DocumentsView";
import { AuthContext } from "../../../context/AuthContext";
import { useNavigate } from "react-router-dom";

function AccordionCard({
  title,
  icon,
  isOpen,
  onToggle,
  children,
  isRetailerMobile,
}) {
  return (
    <div
      className={`overflow-hidden rounded-2xl transition-all duration-300 ${
        isRetailerMobile
          ? "bg-white/20 backdrop-blur-xl border border-white/30"
          : "bg-white border border-slate-200 shadow-sm"
      }`}
    >
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between px-4 py-4"
      >
        <div className="flex items-center gap-3">
          {icon}
          <span className="font-semibold text-slate-800">
            {title}
          </span>
        </div>

        <ChevronDown
          size={18}
          className={`transition-transform duration-300 ${
            isOpen ? "rotate-180" : ""
          }`}
        />
      </button>

      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{
              duration: 0.25,
            }}
            className="overflow-hidden"
          >
            <div className="px-4 pb-4 border-t border-slate-200/20">
              {children}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}


export default function ProfileView({}) {
  const navigate = useNavigate();
  const authUserString = localStorage.getItem("authUserData");
  const authUser = authUserString ? JSON.parse(authUserString) : null;

  const LoginUserName = authUser?.name || authUser?.business_name || authUser?.first_name;
  const loginUserCode = authUser?.org_code;
  const userRole = authUser?.role;

  const isMpinActive = authUser?.is_mpin_active === 1;

  const { logout } = useContext(AuthContext);

  const fileInputRef = useRef(null);
  const [uploading, setUploading] = useState(false);


  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [changing, setChanging] = useState(false);

  // const [showMpinModal, setShowMpinModal] = useState(false);
  const [newMpin, setNewMpin] = useState(["", "", "", ""]);
  const [confirmMpin, setConfirmMpin] = useState(["", "", "", ""]);
  const newRefs = useRef([]);
  const confirmRefs = useRef([]);


  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);


  const [openSections, setOpenSections] = useState({
    profile: true,
    password: false,
    mpin: false,
    security: false,
    legal: false,
  });

  const toggleSection = (key) => {
    setOpenSections((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

useEffect(() => {
  const handleResize = () => setIsMobile(window.innerWidth < 640);
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

 const isRetailerMobile =
    (Number(authUser?.role) === 5 || Number(authUser?.role) === 6) && isMobile;

  const passwordRules = {
  length: (v) => v.length >= 8,
  upper: (v) => /[A-Z]/.test(v),
  lower: (v) => /[a-z]/.test(v),
  digit: (v) => /\d/.test(v),
  special: (v) => /[^A-Za-z0-9]/.test(v),
};

function validatePassword(pwd) {
  return {
    length: passwordRules.length(pwd),
    upper: passwordRules.upper(pwd),
    lower: passwordRules.lower(pwd),
    digit: passwordRules.digit(pwd),
    special: passwordRules.special(pwd),
  };
}

const passwordStatus = validatePassword(newPassword);
const allValid =
  Object.values(passwordStatus).every(Boolean) &&
  newPassword === confirmPassword &&
  oldPassword.length > 0;



  const formatList = (value) => {
  if (!value) return null;
  if (Array.isArray(value)) return value.join(", ");
  return value;
};

  const handlePhotoChange = async (
    e
  ) => {

    const file =
      e.target.files[0];

    if (!file)
      return;

    try {

      setUploading(
        true
      );

      /* ---------------- STEP 1: UPLOAD FILE ---------------- */

      const uploadForm =
        new FormData();

      uploadForm.append(
        "file",
        file
      );

      uploadForm.append(
        "tag",
        "logo"
      );

      const uploadResponse =
        await axios.post(
          `${BASE_URL}warranty/upload-file`,
          uploadForm,
          {
            headers: {
              Accept:
                "application/json",

              "Content-Type":
                "multipart/form-data",
            },
          }
        );

      const uploadJson =
        uploadResponse.data;

      if (
        !uploadJson?.data
          ?.file_url
      ) {

        throw new Error(
          "File upload failed"
        );
      }

      const fileUrl =
        uploadJson.data.file_url;

      /* ---------------- STEP 2: UPDATE PROFILE ---------------- */

      const updateResponse =
        await axios.post(
          `${BASE_URL}common/update`,
          {
            contact_email:
              authUser.contact_email,

            logo:
              fileUrl,

            pincode:
              authUser.pincode,

            role:
              authUser.role,
          },
          {
            headers: {
              Accept:
                "application/json",

              "Content-Type":
                "application/json",
            },
          }
        );

      const updateJson =
        updateResponse.data;

      if (
        !updateJson?.status
      ) {

        throw new Error(
          "Profile update failed"
        );
      }

      /* ---------------- STEP 3: UPDATE SESSION ---------------- */

      const updatedUser = {

        ...authUser,

        logo:
          fileUrl,
      };

      localStorage.setItem(
        "authUserData",
        JSON.stringify(
          updatedUser
        )
      );

      /* ---------------- STEP 4: REFRESH UI ---------------- */

      window.dispatchEvent(
        new Event(
          "storage"
        )
      );

    } catch (err) {

      console.error(
        err
      );

      alert(
        err?.response?.data
          ?.message ||
        "Failed to update logo"
      );

    } finally {

      setUploading(
        false
      );
    }
  };

const handleBoxChange = (e, index, type = "new") => {
  const value = e.target.value.replace(/\D/g, "");

  const updated =
    type === "new" ? [...newMpin] : [...confirmMpin];

  if (!value) {
    updated[index] = "";

    type === "new"
      ? setNewMpin(updated)
      : setConfirmMpin(updated);

    return;
  }

  updated[index] = value[0];

  type === "new"
    ? setNewMpin(updated)
    : setConfirmMpin(updated);

  if (index < 3) {
    const nextRef =
      type === "new"
        ? newRefs.current[index + 1]
        : confirmRefs.current[index + 1];

    nextRef?.focus();
  }
};

const handleKeyDown = (e, index, type = "new") => {
  if (e.key === "Backspace") {
    const updated =
      type === "new" ? [...newMpin] : [...confirmMpin];

    if (updated[index]) {
      updated[index] = "";
    } else if (index > 0) {
      const prevRef =
        type === "new"
          ? newRefs.current[index - 1]
          : confirmRefs.current[index - 1];

      prevRef?.focus();
    }

    type === "new"
      ? setNewMpin(updated)
      : setConfirmMpin(updated);
  }
};

const handleChangePassword = async () => {

  if (!allValid)
    return;

  try {

    setChanging(
      true
    );

    // ✅ Get user ID from local storage
    const userId =
      authUser?.id;

    // ✅ Decide endpoint based on role
    let endpoint =
      "";

    if (
      [1, 2, 4, 5].includes(
        authUser?.role
      )
    ) {

      endpoint =
        `${BASE_URL}company/change-password/${userId}`;

    } else if (
      authUser?.role === 3
    ) {

      endpoint =
        `${BASE_URL}company/employee/change-password/${userId}`;

    } else {

      throw new Error(
        "Password change not allowed for this role"
      );
    }

    const response =
      await axios.post(
        endpoint,
        {
          old_password:
            oldPassword,

          new_password:
            newPassword,
        },
        {
          headers: {
            Accept:
              "application/json",

            "Content-Type":
              "application/json",
          },
        }
      );

    const json =
      response.data;

    if (
      !json?.status
    ) {

      throw new Error(
        json?.message ||
        "Password change failed"
      );
    }

    toast.success(
      "Password changed successfully 🎉"
    );

    setOldPassword(
      ""
    );

    setNewPassword(
      ""
    );

    setConfirmPassword(
      ""
    );

  } catch (err) {

    toast.error(
      err?.response?.data
        ?.message ||
      err?.message ||
      "Failed to change password"
    );

  } finally {

    setChanging(
      false
    );
  }
};

const handleSubmitMpin = async () => {
  const mpinValue = newMpin.join("");
  const confirmValue = confirmMpin.join("");

  if (mpinValue.length !== 4)
    return toast.error("Enter 4 digit MPIN");

  if (mpinValue !== confirmValue)
    return toast.error("MPIN does not match");

  try {
    const endpoint = isMpinActive
      ? `${BASE_URL}common/update-mpin`
      : `${BASE_URL}common/set-mpin`;

    await axios.post(endpoint, {
      company_id: authUser.id,
      m_pin: mpinValue,
    });

    toast.success(
      isMpinActive ? "MPIN updated" : "MPIN set successfully"
    );

    // ✅ Update local storage first
    const updatedUser = {
      ...authUser,
      is_mpin_active: 1,
    };

    localStorage.setItem(
      "authUserData",
      JSON.stringify(updatedUser)
    );

    localStorage.setItem("isMpinActive", "1");

    // ✅ trigger storage sync 
    window.dispatchEvent(new Event("storage"));

    // reset fields
    setNewMpin(["", "", "", ""]);
    setConfirmMpin(["", "", "", ""]);

    // ✅ reload after update
    setTimeout(() => {
      window.location.reload();
    }, 500);

  } catch (err) {
    toast.error("Failed to update MPIN");
  }
};

const roleDisplayName = {
    1: "Admin",
    2: "Master Channel Partner",
    3: "Employee",
    4: "Channel Partner",
    5: "Authorized Retail Partner",
    6: "Promoter",
    7: "Customer",
  };

   const handleLogout = () => {
  logout();
  navigate("/login", { replace: true });
};

  const handleForceLogout = () => {
  logout();
  navigate("/login", { replace: true });
};

  return (
    <div className="space-y-4">
      <SectionCard
        title="My Profile"
        isRetailerMobile={isRetailerMobile}
        // className="md:bg-white bg-white/10 backdrop-blur-2xl border border-white/30 shadow-[0_20px_50px_rgba(31,38,135,0.25)]"
      >
        <div className="flex flex-col md:flex-row gap-4 text-sm">
          <div className="flex-shrink-0 flex flex-col items-center gap-2">
            <div className="w-16 h-16 rounded-2xl bg-blue-600 flex items-center justify-center overflow-hidden">
              {authUser?.logo ? (
                <img
                  src={`${authUser.photo_url || authUser.logo}?v=${Date.now()}`}
                  alt="Profile"
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                  }}
                />
              ) : (
                <span className="text-white text-xl font-semibold">
                  {LoginUserName?.charAt(0)}
                </span>
              )}
            </div>
          {authUser?.role === 2 && (
           <button
              onClick={() => fileInputRef.current.click()}
              className="text-[11px] px-2.5 py-1.5 rounded-lg border border-slate-200 text-slate-700 bg-slate-50 hover:bg-slate-100"
            >
              {uploading ? "Uploading..." : "Edit Photo"}
            </button>
            )}
            <input
              type="file"
              ref={fileInputRef}
              accept="image/*"
              hidden
              onChange={handlePhotoChange}
            />

          </div>
          <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-3">
            <div>
              <div className="text-[11px] text-slate-500">Full Name</div>
              <div className="text-sm font-semibold text-slate-800">
                {authUser?.contact_person || `${authUser?.first_name} ${authUser?.last_name}`}
              </div>
            </div>
            <div>
              <div className="text-[11px] text-slate-500">Role</div>
              <div className="text-sm font-semibold text-slate-800">
                {roleDisplayName[authUser?.role] || "Unknown"}
              </div>

            </div>
            <div>
              <div className="text-[11px] text-slate-500">Mobile</div>
              <div className="text-sm font-semibold text-slate-800">
                {authUser?.contact_phone || authUser?.official_phone}
              </div>
            </div>
            <div>
              <div className="text-[11px] text-slate-500">Email</div>
              <div className="text-sm font-semibold text-slate-800">
                {authUser?.contact_email || authUser?.official_email}
              </div>
            </div>
            { authUser?.role === 5 && (
            <div>
              <div className="text-[11px] text-slate-500">Store Name</div>
              <div className="text-sm font-semibold text-slate-800">
                {authUser?.business_name }
              </div>
            </div>
            )}
            <div>
                <div className="text-[11px] text-slate-500">
                  {authUser?.role === 3 ? "Assigned Location" : "Location"}
                </div>

                <div className="text-sm font-semibold text-slate-800">
                  {authUser?.role === 3 ? (
                    <>
                      {formatList(authUser?.district) && (
                        <span>{formatList(authUser.district)}</span>
                      )}

                      {formatList(authUser?.state) && (
                        <span>
                          {formatList(authUser.district) ? ", " : ""}
                          {formatList(authUser.state)}
                        </span>
                      )}

                      {formatList(authUser?.pincodes) && (
                        <span>
                          {(authUser.district || authUser.state) ? ", " : ""}
                          {formatList(authUser.pincodes)}
                        </span>
                      )}

                      {!authUser?.district && !authUser?.state && !authUser?.pincodes && (
                        <span className="text-slate-400">No location assigned</span>
                      )}
                    </>
                  ) : (
                    <>
                      {authUser?.address_line1 && <span>{authUser.address_line1}, </span>}
                      {authUser?.district && <span>{authUser.district}, </span>}
                      {authUser?.state && <span>{authUser.state}</span>}
                      {authUser?.pincode && <span>, {authUser.pincode}</span>}
                    </>
                  )}
                </div>
              </div>

            <div>
              <div className="text-[11px] text-slate-500">Joined On</div>
              <div className="text-sm font-semibold text-slate-800">
                {formatDateTime(authUser?.created_at)}
              </div>
            </div>
          </div>
        </div>
      </SectionCard>

      { authUser?.role === 2 &&( <Account/>)}

     {[1,2,3,4,5].includes(authUser?.role) && (
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-6">

           <AccordionCard
              title="Change Password"
              icon={<Lock size={18} className="text-blue-500" />}
              isOpen={openSections.password}
              onToggle={() => toggleSection("password")}
              isRetailerMobile={isRetailerMobile}
            >

                  {openSections.password && (
                  <>
                  <div className="space-y-6 text-sm">
                    {/* OLD PASSWORD */}
                    <div className="relative">
                      <label className="text-sm font-medium text-slate-700 flex items-center gap-2">
                        Old Password
                        {oldPassword && (
                          <span className="text-emerald-500 text-xs">✔</span>
                        )}
                      </label>

                      <input
                          type={showOld ? "text" : "password"}
                          value={oldPassword}
                          onChange={(e) => setOldPassword(e.target.value)}
                          className={`mt-2 w-full rounded-xl border-2 px-4 py-3 pr-10 focus:outline-none ${
                            isRetailerMobile
                              ? "bg-white/20 backdrop-blur-xl border border-green-500 text-black"
                              : "bg-white border-emerald-400 font-semibold"
                          }`}
                        />

                      <button
                        type="button"
                        onClick={() => setShowOld(!showOld)}
                        className="absolute right-3 top-10 text-slate-400"
                      >
                        {showOld ? <EyeOff size={18} /> : <Eye size={18} />}
                      </button>
                    </div>

                    {/* NEW PASSWORD */}
                    <div className="relative">
                      <label className="text-sm font-medium text-slate-700">
                        New Password
                      </label>

                      <input
                        type={showNew ? "text" : "password"}
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        className={`mt-2 w-full rounded-xl border-2 px-4 py-3 pr-10 font-semibold focus:outline-none ${
                          Object.values(passwordStatus).every(Boolean)
                            ? "border-emerald-400"
                            : "border-rose-400"
                        } ${
                          isRetailerMobile
                            ? "bg-white/20 backdrop-blur-xl  text-black"
                            : "bg-white text-slate-800"
                        }`}
                      />

                      <button
                        type="button"
                        onClick={() => setShowNew(!showNew)}
                        className="absolute right-3 top-10 text-slate-400"
                      >
                        {showNew ? <EyeOff size={18} /> : <Eye size={18} />}
                      </button>

                      {/* RULES */}
                      <div className="mt-3 text-xs">
                        <p className="text-rose-500 font-medium mb-2">
                          Please add all necessary characters to create safe password.
                        </p>

                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-y-2 gap-x-6">
                          {[
                            ["Minimum characters 8", passwordStatus.length],
                            ["One uppercase character", passwordStatus.upper],
                            ["One lowercase character", passwordStatus.lower],
                            ["One special character", passwordStatus.special],
                            ["One number", passwordStatus.digit],
                          ].map(([label, ok]) => (
                            <div
                              key={label}
                              className={`flex items-center gap-2 ${
                                ok ? "text-emerald-600" : "text-slate-400"
                              }`}
                            >
                              <span
                                className={`w-2 h-2 rounded-full ${
                                  ok ? "bg-emerald-500" : "bg-slate-400"
                                }`}
                              />
                              {label}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    {/* CONFIRM PASSWORD */}
                    <div className="relative">
                      <label className="text-sm font-medium text-slate-700">
                        Confirm New Password
                      </label>

                      <input
                        type={showConfirm ? "text" : "password"}
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        className={`mt-2 w-full rounded-xl border-2 px-4 py-3 pr-10 font-semibold focus:outline-none ${
                          confirmPassword && newPassword === confirmPassword
                            ? "border-emerald-400"
                            : "border-slate-300"
                        } ${
                          isRetailerMobile
                            ? "bg-white/20 backdrop-blur-xl text-black"
                            : "bg-white text-slate-800"
                        }`}
                      />

                      <button
                        type="button"
                        onClick={() => setShowConfirm(!showConfirm)}
                        className="absolute right-3 top-10 text-slate-400"
                      >
                        {showConfirm ? <EyeOff size={18} /> : <Eye size={18} />}
                      </button>
                    </div>

                    {/* SUBMIT */}
                    <button
                      disabled={!allValid || changing}
                      onClick={handleChangePassword}
                      className={`w-full rounded-xl py-3 font-semibold  transition ${
                        allValid
                          ? "bg-gradient-to-r from-blue-500 to-blue-600 hover:opacity-90"
                          : "bg-slate-300 cursor-not-allowed"
                      } ${
                          isRetailerMobile
                            ? "bg-white/30 backdrop-blur-xl text-slate-400"
                            : "bg-white text-slate-800"
                        }`}
                    >
                      {changing ? "Updating..." : "Change Password"}
                    </button>
                  </div>
                  </>
                )}
            </AccordionCard>
            </div>

            <div className="lg:col-span-6" id="mpin-section">
             <AccordionCard
                title="MPIN Setup"
                icon={<KeyRound size={18} className="text-emerald-500" />}
                isOpen={openSections.mpin}
                onToggle={() => toggleSection("mpin")}
                isRetailerMobile={isRetailerMobile}
              >
                <div className="space-y-6 text-center">

                  {/* STATUS */}
                  <div className="flex items-center justify-between gap-2">
                    <span className="text-sm font-semibold">
                      Status:
                    </span>
                    <Badge color={isMpinActive ? "green" : "gray"}>
                      {isMpinActive ? "Active" : "Not Set"}
                    </Badge>
                  </div>

                  {/* ENTER MPIN */}
                  <div>
                    <label className="text-[12px] text-slate-500 block mb-3">
                      {isMpinActive ? "New MPIN" : "Set MPIN"}
                    </label>

                    <div className="flex justify-center gap-3">
                      {newMpin.map((digit, index) => (
                        <input
                          key={index}
                          ref={(el) => (newRefs.current[index] = el)}
                          type="tel"
                          inputMode="numeric"
                          maxLength={1}
                          value={digit}
                          onChange={(e) => handleBoxChange(e, index, "new")}
                          onKeyDown={(e) => handleKeyDown(e, index, "new")}
                          className={`w-14 h-14 border border-slate-300 rounded-xl text-center text-xl font-semibold focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none ${
                      isRetailerMobile
                        ? "bg-white/20 backdrop-blur-xl text-black"
                        : "bg-white text-slate-800"
                    }`}
                        />
                      ))}
                    </div>
                  </div>

                  {/* CONFIRM MPIN */}
                  <div>
                    <label className="text-[12px] text-slate-500 block mb-3">
                      Confirm MPIN
                    </label>

                    <div className="flex justify-center gap-3">
                      {confirmMpin.map((digit, index) => (
                        <input
                          key={index}
                          ref={(el) => (confirmRefs.current[index] = el)}
                          type="tel"
                          inputMode="numeric"
                          maxLength={1}
                          value={digit}
                          onChange={(e) => handleBoxChange(e, index, "confirm")}
                          onKeyDown={(e) => handleKeyDown(e, index, "confirm")}
                          className={`w-14 h-14 border border-slate-300 rounded-xl text-center text-xl font-semibold focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none ${isRetailerMobile
                        ? "bg-white/20 backdrop-blur-xl text-black"
                        : "bg-white text-slate-800"
                    }`}
                        />
                      ))}
                    </div>
                  </div>

                  {/* BUTTON */}
                  <button
                    onClick={handleSubmitMpin}
                    className="w-full bg-blue-600 text-white py-2.5 rounded-xl font-semibold hover:bg-blue-700 transition"
                  >
                    {isMpinActive ? "Update MPIN" : "Set MPIN"}
                  </button>

                </div>
              </AccordionCard>
            </div>
        </div>
      )}

      <AccordionCard
        title="Legal Documents"
        icon={<FileText size={18} className="text-violet-500" />}
        isOpen={openSections.legal}
        onToggle={() => toggleSection("legal")}
        isRetailerMobile={isRetailerMobile}
      >
        <DocumentsView />
      </AccordionCard>

      
       <AccordionCard
        title="Security & Login"
        icon={<ShieldCheck size={18} className="text-emerald-500" />}
        isOpen={openSections.security}
        onToggle={() => toggleSection("security")}
        isRetailerMobile={isRetailerMobile}
      >
       {/* <SectionCard title="Security & Login" isRetailerMobile={isRetailerMobile}> */}
        <div className="text-sm space-y-2">
          {/* <div className="flex items-center justify-between">
            <span>Two-factor authentication (2FA)</span>
            <Badge color="gray">Not configured</Badge>
          </div> */}
          <div className="flex items-center justify-between">
            <span>Active session on this device</span>
            <Badge color="green">Active</Badge>
          </div>
          <div className="text-[11px] text-slate-500 pt-2">
            For your security, do not share your login credentials with anyone.
          </div>
        </div>

      {/* </SectionCard> */}
       </AccordionCard>

       <button
          onClick={handleLogout}
          className={`
            w-full
            flex items-center justify-center gap-3
            px-4 py-3
            rounded-2xl
            font-semibold
            transition-all duration-300
            ${
              isRetailerMobile
                ? `
                  bg-red-500/10
                  backdrop-blur-xl
                  border border-red-200/30
                  text-red-600
                  hover:bg-red-500/20
                  active:scale-[0.98]
                `
                : `
                  bg-red-50
                  border border-red-200
                  text-red-600
                  hover:bg-red-100
                `
            }
          `}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M17 16l4-4m0 0l-4-4m4 4H9m4 8H7a2 2 0 01-2-2V6a2 2 0 012-2h6"
            />
          </svg>

          Logout
        </button>

    </div>
  );
}



// import { formatDateTime } from "../../../Component/Common/formatDateTime";
// import { ROLE_LABELS } from "../../../Component/Common/ROLE_LABELS";
// import Badge from "../../../Component/RetUserComponents/Badge";
// import SectionCard from "../../../Component/RetUserComponents/SectionCard";
// import Account from "../../Profile/Account";



// export default function ProfileView({}) {

//   const authUserString = localStorage.getItem("authUserData");
//   const authUser = authUserString ? JSON.parse(authUserString) : null;

//   const LoginUserName = authUser?.name || authUser?.business_name || authUser?.first_name;
//   const loginUserCode = authUser?.org_code;
//   const userRole = authUser?.role;

//   const formatList = (value) => {
//   if (!value) return null;
//   if (Array.isArray(value)) return value.join(", ");
//   return value;
// };

//   return (
//     <div className="space-y-4">
//       <SectionCard title="My Profile">
//         <div className="flex flex-col md:flex-row gap-4 text-sm">
//           <div className="flex-shrink-0 flex flex-col items-center gap-2">
//             <div className="w-16 h-16 rounded-2xl bg-blue-600 text-white flex items-center justify-center text-xl font-semibold">
//               {LoginUserName.charAt(0)}
//             </div>
//             <button className="text-[11px] px-2.5 py-1.5 rounded-lg border border-slate-200 text-slate-700 bg-slate-50 hover:bg-slate-100">
//               Edit Photo
//             </button>
//           </div>
//           <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-3">
//             <div>
//               <div className="text-[11px] text-slate-500">Full Name</div>
//               <div className="text-sm font-semibold text-slate-800">
//                 {authUser?.contact_person || `${authUser?.first_name} ${authUser?.last_name}`}
//               </div>
//             </div>
//             <div>
//               <div className="text-[11px] text-slate-500">Role</div>
//               <div className="text-sm font-semibold text-slate-800">
//                 {ROLE_LABELS[authUser?.role] || "Unknown"}
//               </div>

//             </div>
//             <div>
//               <div className="text-[11px] text-slate-500">Mobile</div>
//               <div className="text-sm font-semibold text-slate-800">
//                 {authUser?.contact_phone || authUser?.official_phone}
//               </div>
//             </div>
//             <div>
//               <div className="text-[11px] text-slate-500">Email</div>
//               <div className="text-sm font-semibold text-slate-800">
//                 {authUser?.contact_email || authUser?.official_email}
//               </div>
//             </div>
//             { authUser?.role === 5 && (
//             <div>
//               <div className="text-[11px] text-slate-500">Store Name</div>
//               <div className="text-sm font-semibold text-slate-800">
//                 {authUser?.business_name }
//               </div>
//             </div>
//             )}
//             <div>
//                 <div className="text-[11px] text-slate-500">
//                   {authUser?.role === 3 ? "Assigned Location" : "Location"}
//                 </div>

//                 <div className="text-sm font-semibold text-slate-800">
//                   {authUser?.role === 3 ? (
//                     <>
//                       {formatList(authUser?.district) && (
//                         <span>{formatList(authUser.district)}</span>
//                       )}

//                       {formatList(authUser?.state) && (
//                         <span>
//                           {formatList(authUser.district) ? ", " : ""}
//                           {formatList(authUser.state)}
//                         </span>
//                       )}

//                       {formatList(authUser?.pincodes) && (
//                         <span>
//                           {(authUser.district || authUser.state) ? ", " : ""}
//                           {formatList(authUser.pincodes)}
//                         </span>
//                       )}

//                       {!authUser?.district && !authUser?.state && !authUser?.pincodes && (
//                         <span className="text-slate-400">No location assigned</span>
//                       )}
//                     </>
//                   ) : (
//                     <>
//                       {authUser?.address_line1 && <span>{authUser.address_line1}, </span>}
//                       {authUser?.district && <span>{authUser.district}, </span>}
//                       {authUser?.state && <span>{authUser.state}</span>}
//                       {authUser?.pincode && <span>, {authUser.pincode}</span>}
//                     </>
//                   )}
//                 </div>
//               </div>

//             <div>
//               <div className="text-[11px] text-slate-500">Joined On</div>
//               <div className="text-sm font-semibold text-slate-800">
//                 {formatDateTime(authUser?.created_at)}
//               </div>
//             </div>
//           </div>
//         </div>
//       </SectionCard>

//       { authUser?.role === 2 &&( <Account/>)}

//       <SectionCard title="Security & Login">
//         <div className="text-sm space-y-2">
//           {/* <div className="flex items-center justify-between">
//             <span>Two-factor authentication (2FA)</span>
//             <Badge color="gray">Not configured</Badge>
//           </div> */}
//           <div className="flex items-center justify-between">
//             <span>Active session on this device</span>
//             <Badge color="green">Active</Badge>
//           </div>
//           <div className="text-[11px] text-slate-500 pt-2">
//             For your security, do not share your login credentials with anyone.
//           </div>
//         </div>
//       </SectionCard>
//     </div>
//   );
// }